import { defaultLocales } from './locale';

// eslint-disable-next-line @typescript-eslint/no-require-imports
const Hypher = require('hypher');
// eslint-disable-next-line @typescript-eslint/no-require-imports
const hyphenationEN = require('hyphenation.en-us');
// eslint-disable-next-line @typescript-eslint/no-require-imports
const hyphenationDE = require('hyphenation.de');

const hypherEN = new Hypher(hyphenationEN);
const hypherDE = new Hypher(hyphenationDE);

export const hyphenate = {
    [defaultLocales.en]: (text: string) => hypherEN.hyphenateText(text),
    [defaultLocales.de]: (text: string) => hypherDE.hyphenateText(text)
};
